import React from 'react'

export default function Navbar() {
    return (
        <div className='flex  items-center justify-center  h-[100px] bg-gray-900 text-white text-[35px] '>
            <i className='fa fa-spotify'/>
            <span className='ml-5'/>
            Spotify
        </div>
    )
}
